import React, { Fragment } from "react";

export const PageWrapper = ({ children }) => {
  return <Fragment>{children}</Fragment>;
};

export const withPageWrapper = Component => {
  return props => (
    <PageWrapper>
      <Component {...props} />
    </PageWrapper>
  );
};
